import { Hammer, Armchair, Settings, CircleHelp } from 'lucide-react';

/** @typedef {'build' | 'furnish' | 'settings' | 'help'} WorkspaceCategory */

const NAV_ITEMS = [
  { id: 'build', label: 'Build', Icon: Hammer },
  { id: 'furnish', label: 'Furnish', Icon: Armchair },
  { id: 'settings', label: 'Settings', Icon: Settings },
  { id: 'help', label: 'Help', Icon: CircleHelp },
];

/**
 * @param {{
 *   activeCategory: WorkspaceCategory;
 *   onCategoryChange: (category: WorkspaceCategory) => void;
 * }} props
 */
function FloorPlanNavigation({ activeCategory, onCategoryChange }) {
  return (
    <nav className="floor-plan-workspace-nav card" aria-label="Floor plan tools">
      {NAV_ITEMS.map(({ id, label, Icon }) => {
        const isActive = activeCategory === id;
        return (
          <button
            key={id}
            type="button"
            className={`floor-plan-workspace-nav-btn${isActive ? ' floor-plan-workspace-nav-btn--active' : ''}`}
            onClick={() => onCategoryChange(/** @type {WorkspaceCategory} */ (id))}
            aria-current={isActive ? 'page' : undefined}
            title={label}
          >
            <Icon size={20} strokeWidth={2} aria-hidden />
            <span className="floor-plan-workspace-nav-label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default FloorPlanNavigation;
